import UploadFileForm from './UploadFileForm';

export default UploadFileForm;
